import React from 'react';
import { Link } from 'react-router-dom';

const Sidebar: React.FC = () => {
  return (
    <nav className="bg-gray-800 text-white w-64 min-h-screen p-4">
      <ul className="space-y-2">
        <li>
          <Link to="/" className="block py-2 px-4 hover:bg-gray-700 rounded">
            Patient Dashboard
          </Link>
        </li>
        <li>
          <Link to="/soap-notes" className="block py-2 px-4 hover:bg-gray-700 rounded">
            SOAP Notes & Sessions
          </Link>
        </li>
        {/* Add other navigation items here */}
      </ul>
    </nav>
  );
};

export default Sidebar;